import React from 'react';
import { type IOptions } from '../../../utils/options';
import { type IOptionProps } from '../_props';

type CheckboxIconProps = {
  value: IOptions['value'];
  selectedItems: IOptionProps['selectedItems'];
};

export default function CheckboxIcon({ value, selectedItems }: CheckboxIconProps) {
  return (
    <span className="relative flex items-center justify-center">
      <input
        className="border-site-neutrals-900 checked:bg-site-neutrals-900 peer h-6 w-6 shrink-0 cursor-pointer appearance-none rounded-sm border-[0.2rem] bg-white checked:border-0 focus:outline-none focus:ring-1 focus:ring-blue-100 focus:ring-offset-0"
        type="checkbox"
        id={value}
        checked={selectedItems.some((item: any) => item.value === value)}
        readOnly
      />
      <svg
        className="stroke-site-neutrals-0 pointer-events-none absolute left-0 right-0 z-10 mx-auto hidden h-4 w-4 outline-none peer-checked:block"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}
